import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  C4_P3_S1_Title: {
    id: `case04.page03.slide01.title`,
  },
  C4_P3_S1_Video_Description: {
    id: `case04.page03.slide01.video.description`,
  },
  C4_P3_S1_Bio_Title: {
    id: `case04.page03.slide01.bio.title`,
  },
  C4_P3_S1_Bio_Text: {
    id: `case04.page03.slide01.bio.text`,
  },
  C4_P3_S1_Link_Label: {
    id: `case04.page03.slide01.link.label`,
  },

  C4_P3_S1_Bio_Button_Label: {
    id: `case04.page03.slide01.bio.button.label`,
  },
  C4_P3_S1_Image_Caption1: {
    id: `case04.page03.slide01.image.caption1`,
  },
});
